import React from "react";

const badge = "inline-flex items-center max-w-[220px] truncate px-2 py-0.5 rounded-md text-xs font-medium border";

export function freightVehicleCapacityStatusCell(row) {
  const on = String(row?.status) === "1";
  return (
    <span
      className={`${badge} ${on ? "border-emerald-200 bg-emerald-50 text-emerald-900" : "border-gray-200 bg-gray-50 text-gray-600"}`}
    >
      {on ? "Active" : "Inactive"}
    </span>
  );
}

function tonnesCell(value) {
  if (value == null || value === "") return <span className="text-gray-400">—</span>;
  return <span>{value} t</span>;
}

export const FREIGHT_VEHICLE_CAPACITY_MASTER_COLUMNS = [
  { key: "id", label: "ID", aliases: [], defaultVisible: false },
  {
    key: "min_load",
    label: "Min load",
    aliases: [],
    defaultVisible: true,
    renderCell: (row) => tonnesCell(row?.min_load)
  },
  {
    key: "max_load",
    label: "Max load",
    aliases: [],
    defaultVisible: true,
    renderCell: (row) => tonnesCell(row?.max_load)
  },
  {
    key: "status",
    label: "Status",
    aliases: [],
    defaultVisible: true,
    sortable: false,
    renderCell: freightVehicleCapacityStatusCell
  },
  { key: "created_at", label: "Created", aliases: ["createdAt"], defaultVisible: false },
  { key: "updated_at", label: "Updated", aliases: ["updatedAt"], defaultVisible: false }
];
